import { createMuiTheme } from '@material-ui/core/styles'

export const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#8000FF',
    },
    secondary: {
      main: '#FA255E',
    },
    text: {
      primary: '#424242',
    },
    // default: {
    //   main: '#FFFFFF',
    // },
  },
})
